import React, { Component } from 'react';
import PropTypes from 'prop-types';
import onClickOutside from 'react-onclickoutside';
import { translate } from 'react-i18next';
import { getLocationText } from '../../utils/geo';


@translate(['journey'], { wait: true })
@onClickOutside
export class AppealEventPopup extends Component {
  handleClickOutside = () => {
    this.props.onAppealCancel();
  };
  handleSubmit = () => {
    this.props.onAppealSubmit(this.comment.value);
  };

  render() {
    const { appealingStatus, t, onAppealCancel, eventContainer: { event: { penalties }, event } } = this.props;
    const submitDisabled = appealingStatus === 'Started';
    let disputeTitle = '';
    let disputeText = null;
    if (penalties.speeding) {
      disputeTitle = (<h4 className="dispute__title">{t('journey:speeding')}
        {t('journey:speeding_1')}
        {penalties.speeding.speedLimitExceedingMax + penalties.speeding.speeding}
        {t('journey:kmph')}
      </h4>);
      disputeText = `${penalties.speeding.speedLimitExceedingMax
      + penalties.speeding.speeding
      + penalties.speeding.speedLimit}${t('journey:kmph_limit')}${penalties.speeding.speedLimit}${t('journey:kmph')}`;
    }
    if (penalties.accelerating) {
      disputeTitle = (<h4 className="dispute__title">{t('journey:accelerating')}</h4>);
      disputeText = null;
    }
    if (penalties.braking) {
      disputeTitle = (<h4 className="dispute__title">{t('journey:breaking')}</h4>);
      disputeText = null;
    }
    if (penalties.cornering) {
      disputeTitle = (<h4 className="dispute__title">{t('journey:cornering')}</h4>);
      disputeText = null;
    }

    return (<div className="marker-popup__content">
      {
          (appealingStatus === 'Unknown' || appealingStatus === 'Started') && <section className="dispute">
            {disputeTitle}
            <address className="dispute__address">{getLocationText(event.geoData)}</address>
            {disputeText && <p className="dispute__text">{disputeText}</p>}

            <div className="dispute__comment">
              <label className="label" htmlFor="comment">{t('journey:comment')}</label>
              <input
                ref={(input) => {
                  this.comment = input;
                }}
                className="input"
                id="comment"
                placeholder={t('journey:comment__placeholder')}
              />
            </div>

            <footer className="dispute__footer">
              <a role="presentation" className="link link_action_cancel" onClick={onAppealCancel}>{t('journey:cancel')}</a>
              <button onClick={this.handleSubmit} disabled={submitDisabled} className="button">
                {submitDisabled ? <span className="spinner" /> : t('journey:submit')}
              </button>
            </footer>
          </section>
        }
      {
          (appealingStatus === 'Done') && <section className="dispute dispute_state_completed">
            <div className="notification notification_status_success">
              <h4 className="notification__title">{t('journey:appeal-success__title')}</h4>
              <p className="notification__text">{t('journey:appeal-success__text')}</p>
            </div>

            <footer className="dispute__footer">
              <a role="presentation" className="link link_action_close" onClick={onAppealCancel}>{t('journey:close')}</a>
            </footer>
          </section>
      }
      {
          (appealingStatus === 'Failed') && <section className="dispute dispute_state_failed">
            <div className="notification notification_status_failed">
              <h4 className="notification__title">{t('journey:appeal-failed__title')}</h4>
              <p className="notification__text">{t('journey:appeal-failed__text')}</p>
            </div>

            <footer className="dispute__footer">
              <a role="presentation" className="link link_action_close" onClick={onAppealCancel}>{t('journey:close')}</a>
            </footer>
          </section>
      }
    </div>
    );
  }
      }

AppealEventPopup.propTypes = {
  appealingStatus: PropTypes.string.isRequired,
  eventContainer: PropTypes.shape({
    penalties: PropTypes.object,
  }).isRequired,
  onAppealCancel: PropTypes.func.isRequired,
  onAppealSubmit: PropTypes.func.isRequired,
};

AppealEventPopup.WrappedComponent.propTypes = {
  t: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Rides/AppealEventPopup.js